import {DataTestAttrs, getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import {ControlButton} from 'reactflow';

import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export interface BaseControlButtonProps {
  icon: BenchlingIconName;
  tooltip?: string;
  onClick: () => void;
  disabled?: boolean;
  'aria-label'?: string;
  dataTestAttrs?: DataTestAttrs;
}

/**
 * Control button for use in <HorizontalControls>, which provides consistent styling.
 */
export default function BaseControlButton({
  icon,
  tooltip,
  onClick,
  disabled,
  'aria-label': ariaLabel,
  dataTestAttrs,
}: BaseControlButtonProps): JSX.Element {
  return (
    <Tooltip text={tooltip} isDisabled={tooltip == null}>
      <ControlButton
        className={classNames('react-flow__controls-button', css(styles.controlButton))}
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel ?? tooltip}
        {...getTestProps(dataTestAttrs)}
      >
        <BenchlingIcon icon={icon} />
      </ControlButton>
    </Tooltip>
  );
}

export const styles = StyleSheet.create({
  controlButton: {
    borderBottom: 'none',
    borderRadius: '4px',
    margin: '2px',
  },
});
